<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"   @btnclick="bthClick" :pageData="pageData"></table-page>
    <UPDATE  ref="childUpdate"  @submit="submit" :updateData="updateData"></UPDATE>
    <UPDATE  ref="rejectUpdate"  @submit="rejectSubmit" :updateData="rejectUpdateData"></UPDATE>
  </div>
</template>

<script>
  //table封装组件
  import tablePage from '@/components/page/table.vue'
  import FORM from '@/components/page/form.vue'
  import UPDATE from '@/components/page/update.vue'
  import Url from '@/views/proxy_cfint/util/url'
  import DateUtil from '@/utils/IM/tradeDataUtil'
  import Qs from 'qs'
  let status = {0:"待审批",1:"拒绝",2:"已审批"}
  let platform = {"GTS2":"PTS","BO":"FTT"}

  export default {
    name: 'list',
    components: {
      tablePage,
      FORM,
      UPDATE
    },
    methods: {

      /*表格按钮点击事件*/
      bthClick (clickName, row) {
        if (clickName == "reject"){
          this.$refs.rejectUpdate.open(row);
        }else if(clickName == "apply"){
          this.dataChanage(Url.adAgent.creditLinePno.apply,row,res => {
            if (res.code == 0){
              this.$refs.childUpdate.close();
              this.$message.success("suc");
            }else{
              this.$message.error(res.message);
            }
          })
        }
      },
      /*查询表单按钮点击事件*/
      formclick(clickName, data){
        if("查询" == clickName){
          this.queryData = data;
          this.queryData.platform = (this.flag == 1?"BO":"GTS2");
          this.$refs.childTable.defaultQueryData(this.queryData);
        }else if("新增" == clickName){
          this.$refs.childUpdate.open();
        }
      },
      /*新增或跟提交数据触发事件*/
      submit(model){
        model.agentCode = model.agentCode.trim();
        model.agentNumber = model.agentNumber.trim();
        model.platform = (this.flag == 1?"BO":"GTS2");
        //根据是否包含id更新还是添加
        this.dataChanage(Url.adAgent.creditLinePno.edit,model,res => {
          if (res.code == 0){
            this.$refs.childUpdate.close();
            this.$message.success("suc");
          }else{
            this.$message.error(res.message);
          }
        })
      },
      rejectSubmit(model){
        //根据是否包含id更新还是添加
        this.dataChanage(Url.adAgent.creditLinePno.reject,model,res => {
          if (res.code == 0){
            this.$refs.rejectUpdate.close();
            this.$message.success("suc");
          }else{
            this.$message.error(res.message);
          }
        })
      },
      dataChanage(url,option,suc,fail){
        this.axios.post(url, Qs.stringify(option || {})).then(res => {
        if(suc && (typeof suc == 'function')) suc(res);
          this.$refs.childTable.defaultGetData(this.queryData);
      }).catch(res => {
          if(fail && (typeof fail == 'function')) fail(res);
          this.$refs.childTable.defaultGetData(this.queryData);
      })
      }
    },
    mounted() {
      console.log(DateUtil.getParamKey(this.$route.params));
    },
    data () {
      return {
        flag:DateUtil.getParamKey(this.$route.params),
        queryData:{},
        /*新增或更新*/
        updateData:{
          cols:[
            { title: '代理编码', field: 'agentCode',required:true},
            { title: '关联交易账号', field: 'agentNumber',required:true},
            { title: '授信额度', field: 'creditLine',type:7,required:true},
            { title: '注意:', field: 'action',data:'如果是给代理授信减额，在授信额度栏直接输入负数.',type: 19},
          ]
        },
        rejectUpdateData:{
          modelName:"拒绝",
          cols:[
            { title: 'id', field: 'id',hidden:true},
            { title: '提案号', field: 'proposalNo',readonly:true},
            { title: '代理编码', field: 'agentCode',readonly:true},
            { title: '关联交易账号', field: 'agentNumber',readonly:true},
            { title: '交易平台', field: 'platform',readonly:true,hidden:true},
            { title: '授信额度', field: 'creditLine',readonly:true},
            { title: '备注', field: 'remark'},
          ]
        },
        /*from查询表单*/
        formData:{
          hasLable: true,
          cols:[
            { title: '代理编码', field: 'agentCode'},
            { title: '代理名称', field: 'name'},
            { title: '开始时间', field: 'startTime',type:5},
            { title: '结束时间', field: 'endTime',type:5},
            { title: '授信状态', field: 'status',type:2,optionList: status,isNumber:true},
            {click:"查询",auth:"proxy_cfint:creditPno:query"},
            {click:"新增",auth:"proxy_cfint:creditPno:add"},
          ]
        },
        /*table生成*/
        pageData: {
          queryUrl: Url.adAgent.creditLinePno.list, //请求路径和参数
          //selection: true,
          sequence: true,
          cols: [
            { title: '提案号', field: 'proposalNo',width:200},
            { title: '代理编码', field: 'agentCode'},
            { title: '关联交易账号', field: 'agentNumber'},
            { title: '代理名称', field: 'name'},
            { title: '授信额度', field: 'creditLine'},
            { title: '交易平台', field: 'platform',render: (data, full) => {
                return platform[data]
              }},
            { title: '状态', field: 'status', render: (data, full) => {
                return status[data]
              }},
            { title: '备注', field: 'remark'},
            { title: '创建时间', field: 'createTime', render: (data, full) => {
                return DateUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
              }},
            { title: '创建人', field: 'creator'},
            { title: '审批人', field: 'approvalUser'},
            { title: '审批时间', field: 'approvalTime', render: (data, full) => {
                return DateUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
              }},
            {title:"操作", btnClick: [
                { name: "同意", size: 'mini', click: 'apply', type: 'primary' ,icon:"el-icon-update",hidden:(data,full)=>{
                    return full.status != 0;
                  },auth:"proxy_cfint:creditPno:apply",confirm:"您确定要同意吗"},
                { name: "拒绝", size: 'mini', click: 'reject', type: 'primary' ,icon:"el-icon-update",hidden:(data,full)=>{
                    return full.status != 0;
                  },auth:"proxy_cfint:creditPno:reject"}]
            }
        ]
        }
      }
    }
  }
</script>
